import React, { PureComponent } from "react";
import styled from "styled-components";
import { cssMainSelector } from "../lib/cssSelectors";
import Image from "./Image";

const Wrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    max-height: 50px;
    max-width: 50px;
    margin: auto;
  }
`;

class OfferResultsLoader extends PureComponent {
  render() {
    return (
      <Wrapper>
        <Image src="loader.svg" alt="loading" responsive />
      </Wrapper>
    );
  }
}

OfferResultsLoader.propTypes = {};

export default OfferResultsLoader;
